import { observer } from "mobx-react";
import Footer from "@/components/footer/Footer";
import Header from "@/components/header/Header";
import SectionsRenderer from '@/components/sections/SectionsRenderer';
import DefaultPageContent from '@/components/page-templates/DefaultPageContent';

const HomePage = observer(({
  pageData,
  featuredProductsList,
  sliderProductsList,
  crossSellProducts,
}) => {

  return (
    <>
      <Header />
      <main className="pt-[5rem] md:pt-[9rem]">
          {!pageData.acf?.sections || pageData.acf.sections.length === 0 ? (
            <DefaultPageContent pageData={pageData} />
          ) : (
            <SectionsRenderer
              sections={pageData.acf.sections}
              featuredProductsList={featuredProductsList}
              sliderProductsList={sliderProductsList}
              crossSellProducts={crossSellProducts}
            />
          )}
      </main>
      <Footer />
    </>
  );
});

export default HomePage;